import { Component, EventListener, triggerPublicEvent } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';

enum States {
	NotEmptyTextInput = 'state-a-text-input--has-value',
}

enum Selectors {
	TextInput = '.js-a-text-input__input',
	Label = '.js-a-text-input__label',
}

@Component('TextInput')
export class TextInput extends GondelJqueryComponent {
	private $input: JQuery<HTMLElement>;
	private $label: JQuery<HTMLElement>;

	public start() {
		this.$input = this.$ctx.find(Selectors.TextInput);
		this.$label = this.$ctx.find(Selectors.Label);
	}

	public sync() {
		this.toggleInputNotEmptyClass();
		this.$input.one('focus', () => triggerPublicEvent('gFormInteractionEvent', this));
	}

	public setAttribute(attribute: string, newValue: string) {
		this.$input.attr(attribute, newValue);

		if (attribute === 'id' && this.$label) {
			this.$label.attr('for', newValue);
		}
	}

	public getAttribute(attribute: string): string {
		return this.$input.attr(attribute)!;
	}

	public get value(): string {
		return this.$input.val() as string;
	}

	public set value(value: string) {
		this.$input.val(value);
		this._handleTextInputChange();
	}

	@EventListener('input', Selectors.TextInput)
	private _handleTextInputChange() {
		this.toggleInputNotEmptyClass();
	}

	private toggleInputNotEmptyClass() {
		if (this.value !== '') {
			this.$input.addClass(States.NotEmptyTextInput);
		} else {
			this.$input.removeClass(States.NotEmptyTextInput);
		}
	}
}
